module.exports = __webpack_public_path__ + "img/6b77c1389841b14f641d22792bd0777f.png";